import { calendarColors } from '../../utils/Constants';
import { getUtcDateStr } from '../../utils/Utils';

export const getCompletedTasksCountStatus = (data) => {
  let completeCount = data?.filter((item) => item.status === 'Completed');
  return data?.length === 0 ? 0 : completeCount?.length;
};

export const filterData = (data, assigneeEmail) => {
  const filteredData = data
    ?.map((task) => {
      // Filter each subTask
      const relevantSubTasks = task?.subTasks
        ?.map((subTask) => {
          // Filter the assignedTo array for each subTask
          const filteredAssignedTo = subTask?.assignedTo?.filter(
            (assignee) => assignee.assigneeEmail === assigneeEmail
          );
          // If there are any matching assignees, update the subTask with the filtered assignedTo list
          if (filteredAssignedTo?.length > 0) {
            return {
              ...subTask, // Keep other properties of the subTask
              assignedTo: filteredAssignedTo // Only include the relevant assignees
            };
          }
          return null; // No relevant assignees, return null
        })
        .filter(Boolean); // Remove subTasks that have no relevant assignees
      // If the task has any relevant subTasks, return the task with those subTasks
      if (relevantSubTasks?.length > 0) {
        return {
          ...task, // Keep other properties of the task
          subTasks: relevantSubTasks // Only include relevant subTasks
        };
      }
    })
    .filter(Boolean);
  return filteredData;
};

export const getStructuredMonthCalendarData = (data) => {
  let convertedToEvents = [];
  let eventCategoriesLegend = [];
  if (data) {
    eventCategoriesLegend = data?.map((name, index) => ({
      color: calendarColors[index],
      id: index.toString(),
      label: name.name
    }));
    if (eventCategoriesLegend?.length) {
      convertedToEvents = data.map((task, index) => ({
        categoryId: eventCategoriesLegend?.[index]?.id,
        details: task?.taskDescription,
        id: task?.taskId?.toString(),
        start: new Date(getUtcDateStr(task?.timeDuration?.start?.split('/')?.reverse()?.join('-'))),
        end: new Date(getUtcDateStr(task?.timeDuration?.end?.split('/')?.reverse()?.join('-'))),
        title: task.name
      }));
    }
  }
  return {
    categoriesLegend: eventCategoriesLegend,
    eventsData: convertedToEvents
  };
};
